/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import AnimatedLottieView from "lottie-react";
import React from "react";

import { styles, Text } from "UpduoLibrary";
import { clamp } from "config/Utilities";
import { View } from "react-native";

import red from "assets/progress_circle_red_lottie";
import green from "assets/progress_circle_green_lottie";

export default function QuotaProgressModalBody({
  lastSessionWasCancelled,
  sessionQuota,
  completedSessions,
}: {
  lastSessionWasCancelled: boolean;
  sessionQuota: number;
  completedSessions: number;
}) {
  const ratio = completedSessions / sessionQuota;
  const lottieAnimationIndex = clamp(Math.round(ratio * 10), 0, 10);
  const lottieAnimation = lastSessionWasCancelled ? red : green;
  const lottieFile = lottieAnimation[lottieAnimationIndex];
  const percentCompletion = Math.min(Math.round(ratio * 100), 100);

  const circleSize = 150;
  return (
    <>
      <Text isHeading={true} style={styles.modalTitleText}>
        {"Progress"}
      </Text>
      <View>
        <AnimatedLottieView
          style={{ width: circleSize }}
          animationData={lottieFile}
          autoPlay={true}
          loop={false}
        />
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: circleSize,
            height: circleSize,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              fontSize: 30,
              fontWeight: "bold",
            }}
          >
            {percentCompletion}
            {"%"}
          </Text>
        </View>
      </View>
      <Text>{"You have completed"}</Text>
      <Text
        style={{
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: 24,
        }}
      >
        {`${completedSessions} out of ${sessionQuota} sessions`}
      </Text>
    </>
  );
}
